import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'

export const ContentWrapper = styled.div`
  margin-bottom: ${LAYOUT.VERTICALSPACEMOBILE};
  blockquote {
    width:80%;
    margin: 1rem auto;
    font-style:italic;
    color: ${COLORS.GREYDARK};
    padding:1.2rem 30px 1.2rem 50px;
    border-left:8px solid ${COLORS.BLUE};
    background: ${COLORS.GREYLIGHT};
    line-height: 1.4;
  }
  p, ul, ol, blockquote {
    font-size: ${FONTS.PARAGRAPHMEDIUM};
    li {
      margin-bottom: .3rem;
    }
  }
  ul, ol {
    padding-left: 4rem;
  }
  a:link, a: visited {
    color: ${COLORS.BLACK}
  }
  h1 {
    font-size: ${FONTS.TITLETWO};
  }
  h2 {
    font-size: ${FONTS.TITLETHREE};
  }
  h3 {
    font-size: ${FONTS.TITLEFOUR};
  }
  img {
    width: auto;
    max-width: 100%;
    display: block;
    margin: auto;
  }
`
